import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-portal-root',
  templateUrl: './portal-root.component.html',
  styleUrls: ['./portal-root.component.scss'],
})
export class PortalRootComponent {
  public translations: any;

  constructor(private translateService: TranslateService) {}

  ngOnInit() {
    this.translations = {
      account: this.translateService.instant('portalAccount'),
      addAddress: this.translateService.instant('portalAddAddress'),
      addEmailAddress: this.translateService.instant('portalAddEmailAddress'),
      addHomeNumber: this.translateService.instant('portalAddHomeNumber'),
      addMobileNumber: this.translateService.instant('portalAddMobileNumber'),
      address: this.translateService.instant('portalAddress'),
      adultIcon: this.translateService.instant('portalAdultIcon'),
      billsFines: this.translateService.instant('portalBillsFines'),
      bookmarks: this.translateService.instant('portalBookmarks'),
      booksCheckedOut: this.translateService.instant('portalBooksCheckedOut'),
      booksOnHold: this.translateService.instant('portalBooksOnHold'),
      by: this.translateService.instant('portalBy'),
      cancel: this.translateService.instant('portalCancel'),
      cardNumber: this.translateService.instant('portalCardNumber'),
      carrier: this.translateService.instant('portalCarrier'),
      changeDefaultCatalog: this.translateService.instant('portalChangeDefaultCatalog'),
      changePassword: this.translateService.instant('portalChangePassword'),
      checkHoldStatus: this.translateService.instant('portalCheckHoldStatus'),
      checkouts: this.translateService.instant('portalCheckouts'),
      checkoutsRequests: this.translateService.instant('portalCheckoutsRequests'),
      city: this.translateService.instant('portalCity'),
      confirmation: this.translateService.instant('portalConfirmation'),
      confirm: this.translateService.instant('portalConfirm'),
      connectAccount: this.translateService.instant('portalConnectAccount'),
      connectOtherAccounts: this.translateService.instant('portalConnectOtherAccounts'),
      connectedAccounts: this.translateService.instant('portalConnectedAccounts'),
      contentPreferences: this.translateService.instant('portalContentPreferences'),
      copyPassphrase: this.translateService.instant('portalCopyPassphrase'),
      create: this.translateService.instant('portalCreate'),
      delete: this.translateService.instant('portalDelete'),
      disconnectAccount: this.translateService.instant('portalDisconnectAccount'),
      displayPassphrase: this.translateService.instant('portalDisplayPassphrase'),
      editAccountInformation: this.translateService.instant('portalEditAccountInformation'),
      editDetails: this.translateService.instant('portalEditDetails'),
      email: this.translateService.instant('portalEmail'),
      emails: this.translateService.instant('portalEmails'),
      events: this.translateService.instant('portalEvents'),
      expiration: this.translateService.instant('portalExpiration'),
      expires: this.translateService.instant('portalExpires'),
      for: this.translateService.instant('portalFor'),
      fullName: this.translateService.instant('portalFullName'),
      generatePassphrase: this.translateService.instant('portalGeneratePassphrase'),
      getCode: this.translateService.instant('portalGetCode'),
      getPassphrase: this.translateService.instant('portalGetPassphrase'),
      getPhrase: this.translateService.instant('portalGetPhrase'),
      getSharePhrase: this.translateService.instant('portalGetSharePhrase'),
      goBack: this.translateService.instant('portalGoBack'),
      hidePassphrase: this.translateService.instant('portalHidePassphrase'),
      holds: this.translateService.instant('portalHolds'),
      homeLibrary: this.translateService.instant('portalHomeLibrary'),
      homePhone: this.translateService.instant('portalHomePhone'),
      homePhoneNumbers: this.translateService.instant('portalHomePhoneNumbers'),
      loading: this.translateService.instant('portalLoading'),
      mail: this.translateService.instant('portalMail'),
      manageBooks: this.translateService.instant('portalManageBooks'),
      manageContent: this.translateService.instant('portalManageContent'),
      managePreferences: this.translateService.instant('portalManagePreferences'),
      membershipExpiration: this.translateService.instant('portalMembershipExpiration'),
      minor: this.translateService.instant('portalMinor'),
      minorIcon: this.translateService.instant('portalMinorIcon'),
      mobileNumber: this.translateService.instant('portalMobileNumber'),
      mobilePhone: this.translateService.instant('portalMobilePhone'),
      mobilePhoneNumbers: this.translateService.instant('portalMobilePhoneNumbers'),
      name: this.translateService.instant('portalName'),
      navigationMenu: this.translateService.instant('portalNavigationMenu'),
      nickname: this.translateService.instant('portalNickname'),
      noPreferenceSelected: this.translateService.instant('portalNoPreferenceSelected'),
      overview: this.translateService.instant('portalOverview'),
      passcode: this.translateService.instant('portalPasscode'),
      passphrase: this.translateService.instant('portalPassphrase'),
      personalizeYourExperience: this.translateService.instant('portalPersonalizeYourExperience'),
      pickUpArea: this.translateService.instant('portalPickUpArea'),
      preferredContactMethod: this.translateService.instant('portalPreferredContactMethod'),
      preferredLocation: this.translateService.instant('portalPreferredLocation'),
      preferredPickupLocation: this.translateService.instant('portalPreferredPickupLocation'),
      preventMoreLinkRequests: this.translateService.instant('portalPreventMoreLinkRequests'),
      readingHistory: this.translateService.instant('portalReadingHistory'),
      readingHistoryDescriptionConfirmation: this.translateService.instant('portalReadingHistoryDescriptionConfirmation'),
      readingHistoryDescriptionSuccess: this.translateService.instant('portalReadingHistoryDescriptionSuccess'),
      recommendations: this.translateService.instant('portalRecommendations'),
      registeredLibraryBranch: this.translateService.instant('portalRegisteredLibraryBranch'),
      removeAddress: this.translateService.instant('portalRemoveAddress'),
      removeHomePhone: this.translateService.instant('portalRemoveHomePhone'),
      removeMobilePhone: this.translateService.instant('portalRemoveMobilePhone'),
      returnToCatalog: this.translateService.instant('portalReturnToCatalog'),
      roomBookings: this.translateService.instant('portalRoomBookings'),
      showingFor: this.translateService.instant('portalShowingFor'),
      showcases: this.translateService.instant('portalShowcases'),
      state: this.translateService.instant('portalState'),
      streetAddress: this.translateService.instant('portalStreetAddress'),
      streetAddressLine2: this.translateService.instant('portalStreetAddressLine2'),
      success: this.translateService.instant('portalSuccess'),
      twoWay: this.translateService.instant('portalTwoWay'),
      unknownAuthor: this.translateService.instant('portalUnknownAuthor'),
      usePhrase: this.translateService.instant('portalUsePhrase'),
      viewDetails: this.translateService.instant('portalViewDetails'),
      welcome: this.translateService.instant('portalWelcome'),
      whoWillThisCodeBeFor: this.translateService.instant('portalWhoWillThisCodeBeFor'),
      yourNextRead: this.translateService.instant('portalYourNextRead'),
      zipCode: this.translateService.instant('portalZipCode')
    };
  }
}
